import { Link } from "gatsby"

/**
 * NavLink component is used to create a link from Craft's navigation plugin.
 * @param {Object} props
 */
export const NavLink = ({
  children,
  className,
  handleClick,
  newWindow,
  nodeUri,
  type,
}) => {
  const strArr = type?.split(`\\`)
  const linkType = strArr[strArr.length - 1]

  if (linkType === "Entry") {
    return (
      <Link to={`/${nodeUri}`} onClick={handleClick} className={className}>
        {children}
      </Link>
    )
  }

  if (linkType === "PassiveType") {
    return (
      <button type="button" onClick={handleClick} className={className}>
        {children}
      </button>
    )
  }
  return (
    <a
      href={nodeUri}
      className={className}
      target={newWindow !== "0" ? newWindow : ""}
    >
      {children}
    </a>
  )
}
